import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { BannerImage, BannerTitle } from "./BannerLogo";
import { NavLinks } from "./NavLinks";
import { MobileBurgerMenu } from "./MobileBurgerMenu";
import { store, Actions } from "../../util/store";
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { API } from "../../util/API";
import { getScreenSize } from "../../util/screenSizeHelpers";
import { useLocation } from "react-router-dom";
import debounce from "lodash/debounce";
import { SubmitWithCriteria } from "../../pages/Submit";

const styles = {
  container: {
    display: { xs: "flex", md: "grid" },
    flexDirection: { xs: "row" },
    gridTemplateColumns: { md: "1fr auto" },
    gridTemplateRows: { md: "1fr auto" },
    alignItems: "center",
    justifyContent: "space-between",
    height: { xs: "60px", md: "80px" },
    padding: { xs: "10px", md: "10px 14px" },
    columnGap: { md: "18px", lg: "24px" },
    rowGap: 0,
    flex: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.22)",
  },
  links: {
    link: {
      marginRight: "60px",
      fontSize: "1rem",
      textDecoration: "none",
      textTransform: "uppercase",
      fontWeight: 600,
      "&:hover": {
        color: "lightgray",
      },
      display: "flex",
      alignItems: "center",
    },
    container: {
      display: "flex",
      flexFlow: "wrap",
      alignItems: "center",
      width: { md: "100%" },
      justifyContent: { md: "space-evenly" },
    },
  },
};

export const BannerContainer = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { dispatch } = useContext(store);
  const [submitOpen, setSubmitOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const onResize = useCallback(() => {
    debounce(() => {
      dispatch({
        type: Actions.SET_SCREEN_SIZE,
        payload: getScreenSize(window.innerWidth),
      });
    }, 500);
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [onResize]);

  useLayoutEffect(() => {
    dispatch({
      type: Actions.SET_SCREEN_SIZE,
      payload: getScreenSize(window.innerWidth),
    });
  }, [dispatch]);

  useEffect(() => {
    API.getAllFromDatabase().then((data) => {
      dispatch({
        type: Actions.GET_DATA,
        payload: data,
      });
    });
  }, [dispatch]);

  return (
    <Box sx={styles.container}>
      <SubmitWithCriteria
        open={submitOpen}
        toggle={() => setSubmitOpen(false)}
      />
      <Box
        sx={{ gridColumn: { md: "1 / 2" }, gridRow: { md: "1 / 2" } }}
      >
        <BannerImage />
      </Box>
      <BannerTitle />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          minWidth: 0,
          gridColumn: { md: "2 / 3" },
          gridRow: { md: "1 / 2" },
        }}
      >
        {isMobile ? (
          <MobileBurgerMenu onSubmit={() => setSubmitOpen(true)} />
        ) : (
          <NavLinks classes={styles.links} />
        )}
      </Box>
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gridColumn: "2 / 3",
            gridRow: "2 / 3",
          }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={() => setSubmitOpen(true)}
            sx={{
              backgroundColor: "#003b73",
              color: "#fff",
              fontWeight: 700,
              fontSize: { md: "12px", lg: "13px" },
              textTransform: "none",
              boxShadow: "none",
              whiteSpace: "nowrap",
              borderRadius: "3px",
              padding: "4px 12px",
              minHeight: 0,
              lineHeight: 1.35,
              "&:hover": {
                backgroundColor: "#002b55",
                boxShadow: "none",
              },
            }}
          >
            Submit a Destination
          </Button>
        </Box>
      )}
    </Box>
  );
};
